module.exports = __webpack_public_path__ + "static/WEDDING E&M-595-270497652524d98f1f4da30c9adcb49f.jpg";